module.exports = {"nav":{"home":"HOME","game":"GAME CENTER","services":"SERVICES","joinus":"CAREERS","joinus_campus":"JOIN US CAMPUS","joinus_socail":"JOIN US SOCIAL","aboutus":"ABOUT US","language":"LANGUAGE","language_zh":"CHINESE","language_en":"ENGLISH","privacy":"Privacy Policy","terms":"Terms Of Service"},"home":{"bole_we":"JOIN BOLEGAMES","join_we":"JOIN BOLEGAMES","wait_you":"We' ve been waiting for you!","msg":"Enter your email again"}}


//////////////////
// WEBPACK FOOTER
// ./src/assets/json/en.json
// module id = 2V0l
// module chunks = 4